import { render, staticRenderFns } from "./Acheteur.vue?vue&type=template&id=ccfab5d8"
import script from "./Acheteur.vue?vue&type=script&lang=js"
export * from "./Acheteur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports